export const screenNames = {
    INTRO: 'intro',
    ABOUT: 'about',
    AUTH: 'auth',
    LOGIN: 'login',
    REGISTRATION: 'registration',
    COLOR_SELECT: 'color-select',
    RULES: 'rules',
    LOOT: 'loot',
    GAME: 'game',
    FINISH: 'finish',
    RESULTS: 'results',
    PAUSE: 'pause',
    RESET_PASSWORD: 'reset-password',
    SET_NEW_PASSWORD: 'set-new-password',
    AUTHORS: 'authors',
    SCORING: 'scoring',
    WINNERS: 'winners'
};

export const bgNames = {
    INTRO: 'intro',
    GAME: 'game',
    WINNERS: 'winners'
};
